import React from "react";
import PageHeader from "../../components/PageHeader";
import AbandonOrdersViewComponent from "../../components/AbandonOrders/AbandonOrdersView";

class AbandonOrdersView extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Abandon Order Detail"
                            Breadcrumb={[
                                { name: "Abandon Order", navigate: "/abandon-orders" },
                                { name: "Abandon Order Detail", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <AbandonOrdersViewComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AbandonOrdersView;
